/*
 * Copyright 2021 LABOR.digital
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2021.03.09 at 13:37
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { configure } from 'mobx';
import { Bootstrap } from './Bootstrap';
import { HmrRegistry } from './HmrRegistry';
import { Es5Adapter } from './Mount/Es5Adapter';
import { Es6Adapter } from './Mount/Es6Adapter';
import { canUseEs6Features } from './Mount/util';
var BitApp = /** @class */ (function () {
    function BitApp(options, autoRun) {
        this._options = Bootstrap.prepareOptions(options);
        this._di = Bootstrap.makeContainer(this);
        this._mountTag = this._options.mountTag;
        if (autoRun !== false) {
            this.run();
        }
    }
    /**
     * Runs the application and returns a promise when it has been mounted to the DOM.
     * NOTE: Until the next version the app runs automatically once the class is created
     * @todo remove the autoRun option in the next release and make this a default
     */
    BitApp.prototype.run = function () {
        var _this = this;
        return Bootstrap
            .runHook('created', this)
            .then(function () {
            _this.mount();
            HmrRegistry.registerApp(_this);
        })
            .then(function () { return Bootstrap.runHook('mounted', _this); })
            .then(function () { return _this; });
    };
    Object.defineProperty(BitApp.prototype, "options", {
        /**
         * Returns the options provided to the application
         */
        get: function () {
            return this._options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitApp.prototype, "mountTag", {
        /**
         * Returns the configured bit mount tag for this app
         */
        get: function () {
            return this._mountTag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitApp.prototype, "di", {
        /**
         * Returns the dependency injection container for this app
         */
        get: function () {
            return this._di;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Internal helper to register the mount bit as a custom element
     * @protected
     */
    BitApp.prototype.mount = function () {
        var app = this;
        if (canUseEs6Features()) {
            window.customElements.define(this.mountTag, /** @class */ (function (_super) {
                __extends(class_1, _super);
                function class_1() {
                    return _super.call(this, app) || this;
                }
                return class_1;
            }(Es6Adapter)));
        }
        else {
            configure({ useProxies: 'never' });
            Es5Adapter.registerApp(this);
        }
    };
    return BitApp;
}());
export { BitApp };
//# sourceMappingURL=BitApp.js.map